import React from 'react';
import { Box, Grid, makeStyles } from '@material-ui/core';
import { AccordionSummary } from '@material-ui/core';
import { Info } from 'react-feather';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import Tooltip from '@material-ui/core/Tooltip';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import {
  formStyle,
  StyledGridLeft,
  StyledCaption,
  StyledShortBody,
  StyledAccordionDetails,
} from 'components/SecondAccordionReleve/styles';
import messages from 'components/SecondAccordionReleve/messages';
import { translate } from 'helpers/intl';
import { StyledValidAccordion } from 'components/SecondAccordionReleve/styles';
import { renderUnit, currencyFormat, renderUnitTaux } from 'utils/string';
import { useSelector } from 'react-redux';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';

const useStyles = makeStyles({
  ...formStyle,
});

interface AccordionReleveSituationType {
  intl: IntlShape;
  versementsEncours: number;
  tauxFrais: number;
  fraisPreleve: number;
  versementsNette: number;
  versementsNetteValorise: number;
  expanded: boolean | String;
  handleChange: Function;
}

const SecondAccordionReleveSituation = ({
  versementsEncours,
  tauxFrais,
  fraisPreleve,
  versementsNette,
  versementsNetteValorise,
  handleChange,
  expanded,
  ...props
}: AccordionReleveSituationType) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const classes = useStyles();
  return (
    <>
      <StyledValidAccordion
        aria-controls={`panel-content-1`}
        id={`panel-header-1`}
        data-testid={`releve-situation-item-1`}
        onChange={handleChange(`releve-situation-item-1`)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Box px={1} py={1} width="100%">
            <Grid container spacing={3}>
              <Grid item>
                <Grid item>
                  <Grid container spacing={1}>
                    <Grid item>
                      <StyledCaption>
                        {translate(get(messages, 'versementsEncours'), props)}
                      </StyledCaption>
                    </Grid>
                    <StyledGridLeft item xs={1}>
                      <Tooltip
                        title={translate(
                          get(messages, 'versementsNetteDescription'),
                          props,
                        )}
                      >
                        <Info className={classes.infoIcon} fontSize={'small'} />
                      </Tooltip>
                    </StyledGridLeft>
                  </Grid>
                </Grid>

                <Grid item dir="ltr">
                  <Box marginBottom={0}>
                    <StyledShortBody reverse={reverse}>
                      {currencyFormat(versementsEncours) +
                        '' +
                        renderUnit(versementsEncours, reverse)}
                    </StyledShortBody>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </AccordionSummary>

        <StyledAccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <Grid container direction="column">
                <StyledCaption>
                  {translate(get(messages, 'tauxFraisTitle'), props)}
                </StyledCaption>

                <Grid item dir="ltr">
                  <StyledShortBody reverse={reverse}>
                    {tauxFrais + '' + renderUnitTaux(tauxFrais)}
                  </StyledShortBody>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Grid container direction="column">
                <StyledCaption>
                  {translate(get(messages, 'montantFraisPréleve'), props)}
                </StyledCaption>

                <Grid item dir="ltr">
                  <StyledShortBody reverse={reverse}>
                    {currencyFormat(fraisPreleve) +
                      '' +
                      renderUnit(fraisPreleve, reverse)}
                  </StyledShortBody>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Grid container direction="column">
                <StyledCaption>
                  {translate(get(messages, 'versmentsNette'), props)}
                </StyledCaption>
                <Grid item dir="ltr">
                  <StyledShortBody reverse={reverse}>
                    {currencyFormat(versementsNette) +
                      '' +
                      renderUnit(versementsNette, reverse)}
                  </StyledShortBody>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Grid container direction="column">
                <StyledCaption>
                  {translate(get(messages, 'versementsNetteValorises'), props)}
                </StyledCaption>
                <Grid item dir="ltr">
                  <StyledShortBody reverse={reverse}>
                    {currencyFormat(versementsNetteValorise) +
                      '' +
                      renderUnit(versementsNetteValorise, reverse)}
                  </StyledShortBody>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </StyledAccordionDetails>
      </StyledValidAccordion>
    </>
  );
};

export default injectIntl(SecondAccordionReleveSituation);
